// The Companies House not-found support card: what Re-check Companies House's answer means, and the notes Resolve needs. The
// rescore refusals and the Suppress checks are the trust-score review card's (trust-score-review-logic.ts). Pure, so the unit
// tests import it.
import { NOTES_MAX, rescoreResult, type LambdaAnswer, type RescoreResult } from './trust-score-review-logic.js';

/** What companies-house/trust-score/rescore's answer means on this card: a score now exists, or why not. */
export function recheckResult(answer: LambdaAnswer): RescoreResult {
  const result = rescoreResult(answer);
  if (!result.ok) return result;
  // wentToReview is false when the new score matches the one already reviewed, so no review was queued
  return {
    ok: true,
    message:
      answer.wentToReview === false
        ? 'Companies House re-checked: the trust score was calculated.'
        : 'Companies House re-checked: the trust score was calculated and has gone to the trust-score review queue.',
  };
}

/** Why the notes can't go with Resolve, or null when they can: Resolve needs them, saying what support did. */
export function resolveNotesProblem(notes: string): string | null {
  const trimmed = notes.trim();
  if (trimmed === '') return 'Say what you did to resolve this.';
  if (trimmed.length > NOTES_MAX) return `Notes can be at most ${NOTES_MAX} characters.`;
  return null;
}
